import {Component, input, OnChanges} from '@angular/core'
import {EChartsOption} from 'echarts'
import * as echarts from 'echarts/core'
import {EChartsType} from 'echarts/core'
import {ChartBaseComponent} from '../chart-base/chart-base.component'
import {NgxEchartsDirective, provideEchartsCore} from 'ngx-echarts'
import {GridComponent, TitleComponent, TooltipComponent} from 'echarts/components'
import {CanvasRenderer} from 'echarts/renderers'
import {BarChart} from 'echarts/charts'

echarts.use([BarChart, TooltipComponent, TitleComponent,
  GridComponent, CanvasRenderer])

@Component({
  selector: 'spb-bar',
  imports: [
    NgxEchartsDirective
  ],
  templateUrl: './bar.component.html',
  styleUrl: './bar.component.scss',
  providers: [
    provideEchartsCore({echarts}),
    // This is important so that we can viewChild<ChartBaseComponent>
    {provide: ChartBaseComponent, useExisting: BarComponent}
  ]
})
export class BarComponent extends ChartBaseComponent implements OnChanges {
  public data = input.required<number[]>()

  public option: EChartsOption = {
    grid: {
      top: 80,
      bottom: 30
    },
    xAxis: {
      type: 'value',
      position: 'top',
      splitLine: {
        lineStyle: {
          type: 'dashed'
        }
      }
    },
    yAxis: {
      type: 'category',
      axisLine: {show: false},
      axisLabel: {show: false},
      axisTick: {show: false},
      splitLine: {show: false}
    },
    series: [
      {
        type: 'bar',
        label: {
          show: true
        },
        data: [
          {value: -5, label: {position: 'right'}},
          {value: 10, label: {position: 'right'}},
          {value: -4, label: {position: 'right'}}
        ]
      }
    ]
  }

  // Placeholder, value set from template
  public myChart!: EChartsType

  public ngOnChanges() {
    const option: any = this.option
    option.series[0]!.data = this.data().map(d => ({value: d, label: {position: 'right'}}))
    // Replace to trigger updates
    this.option = {...this.option}
  }

  // Return the data url from the chart.
  protected override print(): string {
    return this.myChart.getDataURL({
      pixelRatio: 2,
      backgroundColor: '#fff'
    })
  }
}
